import { createContext, useState } from "react";

export const BGContext = createContext();

const intialBGFilters = {
  gender: "",
  birthLocation: "",
  residentLocation: "",
  religiousBelief: "",
  motherTongue: "",
  qualification: "",
  professionSector: "",
  professionalDesignation: "",
  annualIncome: "",
  familyType: "",
  dietType: "",
  reqstatus: "",
  profileInterestStatus: "",
  subscription: "",
  isApproved: "",
  startDate: "",
  endDate: "",
};

export const BGProvider = ({ children }) => {
  const [bgSearchTerm, setBgSearchTerm] = useState("");
  const [bgFilters, setBgFilters] = useState(intialBGFilters);

  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [Contextlimit] = useState(20);
  const [ContextReload, ContextSetReload] = useState(false);

  return (
    <BGContext.Provider
      value={{
        bgSearchTerm,
        setBgSearchTerm,
        bgFilters,
        setBgFilters,
        intialBGFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
      }}
    >
      {children}
    </BGContext.Provider>
  );
};
